import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取空运出口
export function getAeJobDetail(uuid) {
  return request({
    url: URL.booking.airExport.aeDetail,
    method: 'get',
    params: { uuid }
  })
}

// 获取空运出口-关联其他子表取出
export function loadAirExportJobRelated(data) {
  return request({
    url: URL.booking.airExport.aeDetail,
    method: 'post',
    data: data
  })
}

export function findAirExportJobByNo() {
  // todo-shengsheng  Desc:
  return { data: { list: [] }}
}

// 空出订舱
export function bookingRequest(data) {
  return request({
    url: URL.booking.airExport.bookingRequest,
    method: 'post',
    data
  })
}

// 查询订舱
export function queryBooking(params) {
  return request({
    url: URL.booking.airExport.queryBooking,
    method: 'get',
    params
  })
}

// 更新订舱
export function updateBooking(data, params) {
  return request({
    url: URL.booking.airExport.updateBooking,
    method: 'put',
    data,
    params
  })
}
